package com.taocent.simple.compose.component.blockrichtext.internal.registry

import androidx.compose.ui.text.AnnotatedString
import com.taocent.simple.compose.component.blockrichtext.DocumentBlock
import kotlin.reflect.KClass

interface BlockSerializer<T : DocumentBlock> {

    val kind: BlockKind

    val blockClass: KClass<@UnsafeVariance T>

    fun typeName(): String

    fun toJson(block: @UnsafeVariance T): String

    fun toJson(block: @UnsafeVariance T, contentResolver: ((DocumentBlock) -> AnnotatedString?)? = null): String {
        return toJson(block)
    }

    fun fromJson(root: Map<String, Any?>): T?

    @Suppress("UNCHECKED_CAST")
    fun toJsonAny(block: DocumentBlock): String = toJson(block as T)
}
